import { useContext, useState } from "react";
import { Modal } from "@mui/material";
import Image from "next/image";
import cities from "../json/cities.json";
import { useTranslation } from "@/app/i18n/client";
import Close from "@/assets/images/icons/close.svg";
import Search from "@/assets/images/icons/search.svg";
import CityItem from "@/common/customElements/CityItem";
import HexagonButton from "@/common/customElements/HexagonButton";
import InputWithIcon from "@/common/customElements/inputWithIcon";
import { AbsoluteDiv } from "@/common/divs";
import { AlmostBoldText, SemiBoldText } from "@/common/texts";
import FirebaseContext from "@/context/firebaseContext/firebaseContext";
import { useTrack } from "@/hooks/useTrack";
import { Community } from "@/model";
import {
  CityType,
  FirebaseContextType,
  ModalSearchCityProps,
} from "@/types/components";
import {
  NEUTRO_TITLES_COLOR,
  PRIMARY_BUTTON_COLOR,
  PRIMARY_BUTTON_COLOR_DISSABLED,
} from "@/utils/constants";

const ModalSearchCity: React.FC<ModalSearchCityProps> = ({
  open,
  setOpen,
  communities,
  valuesState,
  setCityState,
  changeValuesForFetch,
}) => {
  const { t } = useTranslation();
  const [cityToSearch, setCityToSearch] = useState<string>("");
  const [filteredCities, setFilteredCities] = useState<CityType[]>([]);
  const { trackEvent, TrackCustomEvents } = useTrack();
  const { logAnalyticsEvent } = useContext(
    FirebaseContext,
  ) as FirebaseContextType;
  const handleChangeCity = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCityToSearch(event.target.value);
    setFilteredCities(
      cities.filter(
        (city) =>
          city.community
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(
              event.target.value
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, ""),
            ) ||
          city.province
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(
              event.target.value
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, ""),
            ),
      ),
    );
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="centerModal cities-modal">
        <AbsoluteDiv right="24px" top="24px">
          <HexagonButton
            onClick={() => setOpen(false)}
            width="32px"
            backgroundColor={PRIMARY_BUTTON_COLOR}
          >
            <Image
              alt="close"
              width="16"
              height="16"
              src={Close.src}
              style={{
                position: "absolute",
                top: "20%",
                left: "27%",
              }}
            />
          </HexagonButton>
        </AbsoluteDiv>
        <section style={{ paddingTop: "32px" }}>
          <AlmostBoldText
            fontSize="24px"
            color={NEUTRO_TITLES_COLOR}
            className="text-padding-align"
          >
            {t("activity.map.search_city")}
          </AlmostBoldText>
          <div style={{ paddingTop: "24px", paddingBottom: "24px" }}>
            <InputWithIcon
              iconSrc={Search.src}
              color={PRIMARY_BUTTON_COLOR_DISSABLED}
              placeholder={t("activity.map.search_city")}
              name="city"
              onChange={(e) => handleChangeCity(e)}
              value={cityToSearch}
            />
          </div>
          <div>
            {cityToSearch.length > 0 ?
              filteredCities.length > 0 ?
                filteredCities.map((city: CityType, index: number) => (
                  <CityItem
                    key={index}
                    city={city.province}
                    onClick={() => {
                      if (valuesState) {
                        valuesState.current = {
                          ...valuesState.current,
                          lat: city.latitude,
                          lon: city.longitude,
                          city: city.province,
                          distance: city.radius,
                        };
                        delete valuesState.current.community;
                        if (changeValuesForFetch) changeValuesForFetch();
                      }
                      setCityState(city.province);
                      setOpen(false);
                    }}
                  />
                ))
              : <SemiBoldText
                  fontSize="18px"
                  color={NEUTRO_TITLES_COLOR}
                  className="text-padding-align"
                >
                  {t("activities.search.empty.title")}
                </SemiBoldText>

            : communities?.map((city: Community, index: number) => (
                <CityItem
                  key={index}
                  city={city.community ?? ""}
                  onClick={() => {
                    if (valuesState) {
                      valuesState.current = {
                        ...valuesState.current,
                        community: city.id,
                        city: city.community,
                      };
                      trackEvent({
                        name: TrackCustomEvents.EVENT_ACTIVE_REGION,
                        properties: { community: city.community },
                      });
                      logAnalyticsEvent(
                        TrackCustomEvents.EVENT_ACTIVE_REGION_WEB,
                        {
                          community: city.community,
                        },
                      );
                      //@ts-ignore
                      delete valuesState.current.lat;
                      //@ts-ignore
                      delete valuesState.current.lon;
                      if (changeValuesForFetch) changeValuesForFetch();
                    }
                    setCityState(city.community ?? "");
                    setOpen(false);
                  }}
                />
              ))
            }
          </div>
        </section>
      </div>
    </Modal>
  );
};

export default ModalSearchCity;
